import { Base } from './_base.model';

export class AgencyEmailTemplate extends Base {
  id: string;
  agency_id: string;
  name: string;
  subject: string;
  body: string;
  recipient_specific: boolean;
  target_host: boolean;
  target_speaker: boolean;
  target_attendee: boolean;
}
